module.exports = __webpack_public_path__ + "static/media/mid-grade-case.95978a8a.jpg";